<template>
  <div class="menu">
    <form @submit.prevent="onSubmit">
      <section class="section">
        <div class="level is-mobile">
          <div class="level-left">
            <div class="level-item">
              <nav class="breadcrumb" aria-label="breadcrumbs">
                <ul>
                  <li
                    v-for="(item, key) in breadcrumb"
                    :key="item.title"
                    :class="{'is-active': key === breadcrumb.length - 1}"
                    >
                    <router-link :to="item.to" v-if="item.to">
                      {{item.title}}
                    </router-link>
                    <a v-else>{{item.title}}</a>
                  </li>
                </ul>
              </nav>
            </div>
          </div>
          <div class="level-right">
            <div class="level-item">
              <router-link class="button" :to="{name: 'menu'}">
                Back
              </router-link>
            </div>
          </div>
        </div>
      </section>
      <section class="section">
        <b-tabs>
          <b-tab-item label="Content">
            <p class="title">Content</p>
            <b-field label="Slug">
              <b-field>
                <p class="control">
                  <span class="button is-static">
                    <b-icon pack="fas" icon="globe" />
                    <span>{{$websiteUrl}}</span>
                  </span>
                </p>
                <b-input v-model="slug" :disabled="isDisabled" class="is-expanded"/>
              </b-field>
            </b-field>
            <b-field label="Name">
              <b-input v-model="name" :disabled="isDisabled" />
            </b-field>
            <b-field label="Title">
              <b-input v-model="title" :disabled="isDisabled" />
            </b-field>
            <b-field label="Description">
              <b-input v-model="description" type="textarea" :disabled="isDisabled" />
            </b-field>
            <b-field label="Tags">
              <b-taginput
                v-model="tags"
                :data="filteredTags"
                autocomplete
                :allow-new="true"
                field="name"
                icon="tag"
                placeholder="Add a tag"
                @typing="getFilteredTags"
                :disabled="isDisabled"
              />
            </b-field>
          </b-tab-item>
          <b-tab-item label="SEO">
            <seo ref="seo" v-model="meta" :disabled="isDisabled" />
          </b-tab-item>
        </b-tabs>
      </section>
      <section class="section">
        <b-field>
          <button class="button is-success" :disabled="isDisabled">Save</button>
        </b-field>
      </section>
    </form>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import Seo from '@/components/Seo.vue';

export default {
  name: 'my-menu-info',
  components: {
    Seo,
  },
  filters: {
    maxSize(sizes) {
      return `max-width: ${sizes[0]}px; max-height: ${sizes[1]}px;`;
    },
  },
  data() {
    return {
      id: null,
      parentId: null,
      slug: null,
      name: null,
      title: null,
      description: null,
      tags: [],
      meta: {
        title: null,
        description: null,
        ogTitle: null,
        ogDescription: null,
        ogMedia: 'image',
        ogMediaUrl: null,
        ogMediaType: null,
      },
      filteredTags: [],
      fetching: false,
      saving: false,
    };
  },
  computed: {
    ...mapGetters('menu', ['menu']),
    ...mapGetters('tag', ['allTags']),
    breadcrumb() {
      const breadcrumb = [];
      breadcrumb.push({
        title: 'Menu',
      });

      if (this.$route.params.id) {
        breadcrumb.push({
          title: this.title || this.id,
          to: {
            name: 'menu',
          },
        }, {
          title: 'Edit',
        });
      } else {
        breadcrumb.push({
          title: 'Create',
        });
      }

      return breadcrumb;
    },
    isDisabled() {
      return this.fetching || this.saving;
    },
  },
  methods: {
    ...mapActions('menu', [
      'getMenu',
      'saveMenu',
      'saveMenuMeta',
    ]),
    ...mapActions('upload', {
      upload: 'image',
    }),
    ...mapActions('tag', ['getAllTags']),
    getFilteredTags(text) {
      this.filteredTags = this.allTags.filter(tag => (
        tag.name
          .toString()
          .toLowerCase()
          .indexOf(text.toLowerCase()) >= 0
      ));
    },
    parseData() {
      this.id = this.menu.id;
      this.parentId = this.menu.parentId;
      this.slug = this.menu.slug;
      this.name = this.menu.name;
      this.title = this.menu.title;
      this.description = this.menu.description;
      this.name = this.menu.name;
      this.tags = this.menu.Tags.map(i => i.name);

      Object.assign(this.meta, this.menu.Meta);
    },
    async onSubmit() {
      const data = {
        id: this.id,
        parentId: this.parentId,
        slug: this.slug,
        name: this.name,
        title: this.title,
        description: this.description,
        tags: this.tags,
      };

      this.saving = true;

      const menu = await this.saveMenu(data);

      if (this.meta.ogImage) {
        const response = await this.$refs.seo.uploadOgImage();
        this.meta.ogMediaUrl = response.data.url;
      }

      await this.saveMenuMeta({
        id: menu.id,
        params: this.meta,
      });

      try {
        this.$toast.open({
          message: 'Menu saved',
          type: 'is-success',
          duration: 5000,
        });

        if (!this.$route.params.id) {
          this.$router.push({ name: 'menu', params: { id: menu.id } });
        }

        this.saving = false;
      } catch (e) {
        this.$toast.open({
          message: 'Something wrong',
          type: 'is-danger',
          duration: 5000,
        });
      }
    },
  },
  mounted() {
    this.getAllTags();

    if (this.$route.params.id) {
      this.fetching = true;
      this.getMenu(this.$route.params.id).then(() => {
        this.parseData();
      }).finally(() => {
        this.fetching = false;
      });
    }
  },
};
</script>

<style lang="sass" scoped>
.image-preview
  img
    object-fit: contain
    object-position: left
</style>
